import { UtilitarioService } from "@app/services/utilitario.service";
export class RequisicaoFinanceira{
    Id: number;
    ProcessoId: number;
    OrgaoJudiciarioId: number;
    UsuarioCriacaoId: number;
    DataCriacao: string;
    NumeroRequisicao: string;

    ProcessoInstancia: string;
    SucumbenciaRelacionada: string;
    DataAutuacao: string;
    DataPrevisaoRecebimento: string;
    Valor: number;

    PercentualEscritorio: number;
    PercentualCliente: number;
    PercentualEncaminhador: number;
    PercentualSubstabelecido: number;


    RPV: boolean;
    Precatorio: boolean;
    Expedido: boolean;
    Sucumbencia: boolean;
    Recebido: boolean;

    HonorariosAdvogados: RequisicaoFinanceiraAdvogados[];

    constructor(tipoRequisicao: string){
        this.HonorariosAdvogados = [];
        this.PercentualCliente = 0;
        this.PercentualEscritorio = 0;
        this.SucumbenciaRelacionada = "";

        switch(tipoRequisicao){
            case 'RPV':
                this.RPV = true;
                break;
            case 'PRECATORIO':
                    this.Precatorio = true;
                    break;
        }
    }
}

export class RequisicaoFinanceiraAdvogados{
    RequisicaoFinanceiraId: number;
    AdvogadoId: number;
    PercentualAdvogado: number;

    constructor(advogadoId: number, percentual: number){
        this.AdvogadoId = advogadoId;
        this.PercentualAdvogado = percentual;
    }
}

export class RequisicaoFinanceiraHistorico {
    Id: number;
    RequisicaoFinanceiraId: number;
    UsuarioCriacaoId: number;
    UsuarioCriacaoNome: string;
    DataCriacao: string;
    Descricao: string;
}
